import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Const from 'constants';
import PlayersGroupExclusionSwitchersList from './players-group-exclusion-switchers-list';
import PlayersGroupExclusionSwitcher from './players-group-exclusion-switcher';

class RankPlayersGroupExclusionSwitcher extends Component {
    isRankMode() {
        const {activeMode} = this.props;
        return inArray(activeMode, [Const.CAPTAIN_MODE, Const.STAR_MODE, Const.PRO_MODE, Const.FLEX_MODE]);
    }

    render() {
        const {players, activeMode} = this.props;

        if (this.isRankMode()) {
            return <PlayersGroupExclusionSwitcher players={players} activeMode={activeMode} />;
        }

        return <PlayersGroupExclusionSwitchersList players={players} />;
    }
}

export default RankPlayersGroupExclusionSwitcher;
